import { SecureStorage } from './telegram'
import { StateStorage } from 'zustand/middleware'

/**
 * SecureStorage adapter for Zustand persist middleware
 * Uses Telegram's SecureStorage API to store data securely (encrypted)
 *
 * This adapter is compatible with Zustand's persist middleware and provides
 * a secure alternative to localStorage for sensitive data like PIN retries
 * and user restrictions.
 */
export const secureStorageAdapter: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    return await SecureStorage.getItem(name)
  },
  setItem: async (name: string, value: string): Promise<void> => {
    const success = await SecureStorage.setItem(name, value)
    if (!success) {
      throw new Error(`SecureStorage.setItem failed for key: ${name}`)
    }
  },
  removeItem: async (name: string): Promise<void> => {
    const success = await SecureStorage.removeItem(name)
    if (!success) {
      throw new Error(`SecureStorage.removeItem failed for key: ${name}`)
    }
  },
}
